import { Trans } from '@lingui/react/macro';
import type React from 'react';
import { useWizard } from './WizardContext.js';

interface WizardProgressProps {
  numberOfSteps: number;
  hasVehicleLookup: boolean;
}

export const WizardProgress: React.FC<WizardProgressProps> = ({ numberOfSteps, hasVehicleLookup }) => {
  const { currentStep } = useWizard();
  const offset = hasVehicleLookup ? 2 : 1; // +1 to convert 0-based to 1-based, +1 to account for vehicle lookup (if present)
  const displayStep = currentStep + offset;
  const displayTotal = numberOfSteps + (hasVehicleLookup ? 1 : 0); // +1 to account for vehicle lookup (if present)

  return (
    <div className="t4 mb-4" data-testid="header-current-step">
      <Trans
        id="mobility-item-insertion.form.wizard.progress"
        comment="Indicates the current step and total steps in the wizard"
      >
        Step {displayStep} of {displayTotal}
      </Trans>
    </div>
  );
};
